import {useSyncExternalStore} from 'react';
import type {AvatarState} from '../../functions/lib/avatar/renderer';
let state:AvatarState='idle';
let idleTimer:ReturnType<typeof setTimeout>|undefined;
let reactionTimer:ReturnType<typeof setTimeout>|undefined;
const listeners=new Set<()=>void>();
const publish=(next:AvatarState)=>{if(state!==next){state=next;listeners.forEach(listener=>listener());}};
function activity(){
 clearTimeout(idleTimer);
 if(state==='sleepy')publish('idle');
 idleTimer=setTimeout(()=>publish('sleepy'),60_000);
}
function subscribe(listener:()=>void){
 listeners.add(listener);
 if(listeners.size===1){window.addEventListener('pointerdown',activity,{passive:true});window.addEventListener('keydown',activity);activity();}
 return()=>{listeners.delete(listener);if(!listeners.size){window.removeEventListener('pointerdown',activity);window.removeEventListener('keydown',activity);clearTimeout(idleTimer);clearTimeout(reactionTimer);state='idle';}};
}
const snapshot=()=>state;
const serverSnapshot=():AvatarState=>'idle';
export function useAvatarReaction(){return useSyncExternalStore(subscribe,snapshot,serverSnapshot);}
export function celebrateAvatar(next:'happy'|'celebration'){
 clearTimeout(reactionTimer);publish(next);activity();reactionTimer=setTimeout(()=>publish('idle'),4000);
}
